import React from 'react';
import styled from 'styled-components';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import moment from "moment";


const EsReqDeliveryAddInfoBlock = styled.div`
    color: #333333;
    .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        
    }

    .sub-title {
        width: 100px;
        font-size: 13px;
        font-weight: normal;
        line-height: 21px;
        color: #999999;
    }

    .sub-desc {
        font-size: 13px;
        font-weight: normal;
        line-height: 1.69;
    }

    .margin-text {
        margin-bottom: 20px;
        width: 100%;
    }

    .delivery-help {
        padding: 20px;
        border-radius: 4px;
        background-color: #f4f4f4;

        font-size: 13px;
        line-height: 1.69;
        text-align: left;
        color: #666666;
    }
    
    .margin-sub-title {
        margin-bottom: 6px;
    }

    .enter-img {
        position: relative;
        width: 8px;
        height: 8px;
        background: url(/assets/images/icon/enter.png) center center/auto no-repeat;
        background-size: 8px 8px;
        top: 6px;
        margin-right: 8px;
    }

    .enter-content {
        width: calc(100% - 20px);
    }
`;

const EsReqDeliveryAddInfo = ({ detailInfo, esItem }) => {

    const { es_rqst_id, pckg_nm, rqst_date_format, brnd_han, rqst_price,
        es_dscnt_total_price, es_prdct_total_price, es_final_price,
        expr_date, es_dlvry_total_price, es_detail_dlvry_pay_type, total_qty,
        es_pay_price, dsrd_date_format,es_add_dscnt_price_total, rqst_status, cancel_date_format, rqst_date,dsrd_date,dlvry_date
    } = esItem[0];

    const getDsrdDate = () => {
        if(dsrd_date !== null  && dsrd_date !== undefined){
            return moment(dsrd_date).format('YYYY.MM.DD');
        }

        return "";
    }

    const getDeliveryDate = () => {
        if(dlvry_date !== null  && dlvry_date !== undefined){
            return dlvry_date;
        }

        return "";
    }
    
    const getTypeInfo = () => {
        let text = "";

        if(detailInfo.userinfo.area_size !== '0') {
            if(detailInfo.userinfo.area_type === '055202') {
                text="전용";
            } else {
                text="공급";
            }

            text = text + " " + detailInfo.userinfo.area_size;
        }

        if(detailInfo.userinfo.code_nm !== null) {
            if(text.length > 1) {
                text = text + " / " + detailInfo.userinfo.code_nm;
            } else {
                text = detailInfo.userinfo.code_nm;
            }
        }

        if(text.length > 1) {
            return (
            <div>
                <div className="sub-title margin-sub-title">선택 정보</div>
                <div className="sub-desc margin_b-20">{text}</div>
            </div>)
        }
    }

    const getInstallInfo = () => {
        //console.log("detailInfo = " + JSON.stringify(detailInfo))
        if(detailInfo.userinfo.is_install_chrg) {
            return (
                <div>
                    <div className="sub-title margin-sub-title">설치 및 조립 요청</div>
                    <div className="sub-desc margin_b-10">비용 확인 해주세요</div>
                    {
                        detailInfo.userinfo.install_chrg_answer&&detailInfo.userinfo.install_chrg_answer.length>0&&<div className="clearfix margin_b-20">
                        <div className="enter-img f-left"></div>
                        <div className="sub-desc f-left enter-content ">{detailInfo.userinfo.install_chrg_answer}</div>
                    </div>
                    }
                    
                    
                </div>
            )
        }
    }

    const getAnswerStr = () => {
        if (detailInfo.userinfo.es_answer === null ||
            detailInfo.userinfo.es_answer === undefined ||
            detailInfo.userinfo.es_answer === "") {
            return "-"
        } else {
            return detailInfo.userinfo.es_answer;
        }
    }

    const getQuestionStr = () => {
        if (detailInfo.userinfo.es_question === null ||
            detailInfo.userinfo.es_question === undefined ||
            detailInfo.userinfo.es_question === "") {
            return "-"
        } else {
            let errText = detailInfo.userinfo.es_question;;
            if(errText !== null  && typeof(errText) === "string" && errText.length > 0  && errText.indexOf("\n") > -1){
                let text = "";
                text = errText.split("\n").map(function(item, idx) {
                    
                    return (
                        <span key={idx}>
                            {item}
                            <br/>
                        </span>
                     )
                })
                return text;
            } else {
                return errText;
            }
        }
    }

    const getQuestion = () => {
        let question = getQuestionStr();
        let answer = getAnswerStr();

         if ( question !== "-") {
            return (
                <div>
                    <div className="sub-title margin-sub-title">문의 사항</div>
                    <div className="sub-desc margin_b-10">{question}</div>
                    {
                        answer !== "-"&&<div className="clearfix margin_b-20">
                        <div className="enter-img f-left"></div>
                        <div className="sub-desc f-left enter-content ">{answer}</div>
                        </div>
                    }
                    
                    
                </div>
            )
        }
    }

    const validDsrdDesc = () => {
        if(rqst_status === '050102' || rqst_status === '050104' || rqst_status === '050108'|| rqst_status === '050110') {
            return true;
        }

        return false;
    }

    const validDeliveryHelp = () => {
        if(rqst_status === '050105' || rqst_status === '050111') {
            return true;
        }

        return false;
    }

    if(esItem === null || esItem === undefined) {
        return <div/>
    }

    if(detailInfo === null || detailInfo === undefined) {
        return <div/>
    }

    return (
        <EsReqDeliveryAddInfoBlock>
            <div className="title margin-text">배송 정보 및 추가 사항</div>
            <div className="margin-text clearfix">
                <div className="clearfix">
                    <div className="sub-title f-left">희망 배송일</div>
                    <div className="sub-desc f-left">{getDsrdDate()}</div>
                </div>
                {
                validDsrdDesc()&&<div className="delivery-help margin_t-10">
                ※ 확정된 날짜가 아닙니다.<br/>
                희망 배송일자이므로 업체와 상의 후 확정해주세요.
                </div>
                }
            </div>
            
            {
                validDeliveryHelp()
                &&<div className="margin_b-20 clearfix">
                    <div className="clearfix">
                        <div className="sub-title f-left">배송 가능 일자</div>
                        <div className="sub-desc f-left">{getDeliveryDate()}</div>
                    </div>
                    <div className="delivery-help margin_t-10">
                    ※ 예상 배송일입니다.<br/>
                    주문일 기준으로 배송일이 변동될 수 있습니다.
                    </div>
                </div>
            }
            <div className="sub-title margin-sub-title">배송 지역</div>
            <div className="sub-desc margin_b-20">{detailInfo.userinfo.addr1} , {detailInfo.userinfo.addr2}</div>
            {getTypeInfo()}
            {getInstallInfo()}
            {getQuestion()}
        </EsReqDeliveryAddInfoBlock>
    );
};

export default EsReqDeliveryAddInfo;
